import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

const CalendarFrequenciesLookupState = (state: RootState) => state.lookups.calendarFrequencies;

export const selectCalendarFrequencies = (state: RootState) => CalendarFrequenciesLookupState(state).rows;
export const selectCalendarFrequenciesLoading = (state: RootState) => CalendarFrequenciesLookupState(state).loading;

export const selectCalendarFrequencyById = createSelector(
  [selectCalendarFrequencies, (_: RootState, id?: string) => id],
  (rows, id) => rows.find(({ id: rowId }) => id === rowId),
);

export const selectLookupCalendarFrequencies = createSelector(selectCalendarFrequencies, (rows) =>
  rows.map(({ id, name }) => ({ id, name })),
);
